import { createSelector } from '@reduxjs/toolkit';

import { ServiceType } from 'protocol/api/billing_new/dto_services_new_pb';

import { billingModel } from '@/entities/billing';
import { organizationConfig, organizationModel } from '@/entities/organization';

export const selectStorageUsed = createSelector(
  organizationModel.selectors.selectOrganizationStorageSize,
  (storageSize) => storageSize?.Total ?? BigInt(0),
);

export const selectPurchasedStorageLimit = createSelector(
  billingModel.selectors.selectServicesByType(
    ServiceType.ServiceType_Expand_Storage,
  ),
  (storageServices) =>
    storageServices.reduce((total, service) => {
      if (service.Kind.case === 'Countable') {
        return total + service.Kind.value.Limit * organizationConfig.BYTES_PER_GB;
      }

      return total;
    }, BigInt(0)),
);

export const selectTotalStorageLimit = createSelector(
  selectPurchasedStorageLimit,
  (purchasedStorage) => organizationConfig.BASE_STORAGE_LIMIT + purchasedStorage,
);

export const selectStoragePercentage = createSelector(
  selectStorageUsed,
  selectTotalStorageLimit,
  (used, limit) => {
    if (limit === BigInt(0)) {
      return 0;
    }

    return Number((used * BigInt(100)) / limit);
  },
);

export const selectIsStorageWarning = createSelector(
  selectStoragePercentage,
  (percentage) =>
    percentage >= organizationConfig.STORAGE_WARNING_THRESHOLD &&
    percentage < organizationConfig.STORAGE_FULL_THRESHOLD,
);

export const selectIsStorageFull = createSelector(
  selectStoragePercentage,
  (percentage) => percentage >= organizationConfig.STORAGE_FULL_THRESHOLD,
);
